import React from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../../i18n';
import LoadingOverlay from '../LoadingOverlay';
import { useFormLoadingOverlayLoader } from './useFormLoadingOverlayLoader';
import style from './FormLoadingOverlay.module.scss';

const classNameBuilder = classnames.bind(style);

export const FormLoadingOverlay = ({ loadingOverlayText, className, loader: loaderProp }) => {
    const defaultLoader = useFormLoadingOverlayLoader();
    const Loader = loaderProp || defaultLoader;

    return (
        <LoadingOverlay className={classNameBuilder('formLoadingOverlayContainer', className)}>
            <Loader />
            {loadingOverlayText && <FormattedMessage id={loadingOverlayText} defaultMessage="LOADING ..." />}
        </LoadingOverlay>
    );
};

FormLoadingOverlay.propTypes = {
    /** Text to be displayed */
    loadingOverlayText: PropTypes.string,
};
